import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { MysqlSyncService } from '../Global/mysqlSync.service';

import { DataPassService } from '../Global/dataPass.service';

import { CommonFunctionsService } from '../Global/commonFunctions.service';

/**
 * Service pour la gestion des uploads via Dropzone
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable()
export class DropzoneService {

  private commonFunctions;

  serverEndpoint = Globals.serverEndpoint;
  folderName = 'tmp';

  files: Array<any> = []; // Créer un type de donnée pour les fichiers et remplacer any

  config: DropzoneConfigInterface = {
    url: this.serverEndpoint + '/upload',
    maxFilesize: 1000,
    acceptedFiles: 'audio/wav,audio/x-wav,audio/mpeg,audio/vnd.wave,audio/x-flac,audio/flac,audio/mp3,audio/x-aiff,audio/aiff,audio/mp4',
    // uploadMultiple: true,
    uploadMultiple: false,
    // addRemoveLinks: true,
    timeout: 0,
    withCredentials: true, // Important: permet l'envoi des cookies de session

    dictDefaultMessage: '<strong>Choisissez un ou des fichier(s)</strong> ou glissez-déposez ici<br/><i style="font-size: 1em; line-height: 2em;">MP3 320kbps / FLAC / WAV / M4A 256kbps / AIFF</i>',
    dictFallbackMessage: 'Votre navigateur ne supporte pas le drag and drop',
    dictFallbackText: 'Please use the fallback form below to upload your files like in the olden days.',
    dictFileTooBig: 'Le fichier est trop lourd ({{filesize}}Mb). Taille de fichier Max: {{maxFilesize}}Mb.',
    dictInvalidFileType: 'Vous ne pouvez pas uploader des fichiers de ce type.',
    dictResponseError: 'Serveur réponse : {{statusCode}} code.',
    dictCancelUpload: 'Upload quitter',
    dictCancelUploadConfirmation: 'Etes-vous sur de vouloir quitter cet upload ?',
    dictRemoveFile: 'Retirer fichier',
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: 'Vous ne pouvez pas uploader plus de fichiers.',

    renameFile: (file) => {
      return this.commonFunctions ? this.commonFunctions.remove_accents(file.name).replace(/"/g, '') : file.name;
    },

    params: {
      destinationFolder: ''
    },

    /*sending: (file, xhr, formData) => {
      formData.append("insurance_type", 'test');  //name and value
      formData.append("insurance_expirationdate", 'tests'); //name and value
    },*/

    previewTemplate: `<div class="dz-preview dz-file-preview">
                        <div class="dz-image">
                            <img data-dz-thumbnail />
                        </div>
                        <div class="dz-details">
                            <div class="dz-size">
                                <span data-dz-size></span>
                            </div>
                            <div class="dz-filename">
                                <span data-dz-name></span>
                            </div>
                        </div>
                        <div class="dz-progress">
                            <span class="dz-upload" data-dz-uploadprogress></span>
                        </div>
                        <div class="dz-error-message">
                            <span data-dz-errormessage></span>
                        </div>
                        <div class="dz-success-mark">
                            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
                                <title>Check</title>
                                <defs></defs>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                    <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z"
                                        id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>
                                </g>
                            </svg>
                        </div>
                        <div class="dz-error-mark">
                            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
                                <title>Error</title>
                                <defs></defs>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                    <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#C61D00" fill-opacity="0.816519475">
                                        <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z"
                                            id="Oval-2" sketch:type="MSShapeGroup">
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <div class="dz-remove" style="display: none">
                            <img src="${Globals.appLocation}/assets/icon/remove.png" alt="Click me to remove the file." data-dz-remove />
                        </div>
                    </div>`
  };

  constructor(private http: HttpClient,
              private mysqlSyncService: MysqlSyncService,
              private dataPassService: DataPassService,
              private commonFunctionsService: CommonFunctionsService) {
    this.commonFunctions = this.commonFunctionsService;
  }

  /**
   * Met à jour le message affiché dans la zone de dépôt selon le seuil de bitrate
   * applicable au compte connecté (réglage admin low_bitrate_allowed dans DU_users)
   */
  setLowBitrateAllowed(lowBitrateAllowed: boolean) {
    this.config.dictDefaultMessage = lowBitrateAllowed
      ? '<strong>Choisissez un ou des fichier(s)</strong> ou glissez-déposez ici<br/><i style="font-size: 1em; line-height: 2em;">MP3 128kbps / FLAC / WAV / M4A 128kbps / AIFF</i>'
      : '<strong>Choisissez un ou des fichier(s)</strong> ou glissez-déposez ici<br/><i style="font-size: 1em; line-height: 2em;">MP3 320kbps / FLAC / WAV / M4A 256kbps / AIFF</i>';
  }

  getTwoDigitDateFormat(monthOrDate) {
    return (monthOrDate < 10) ? '0' + monthOrDate : '' + monthOrDate;
  }

  getRandomFolder() {
    const dateNow = new Date();
    const dayNow = this.getTwoDigitDateFormat(dateNow.getDate()).toString(),
      monthNow = this.getTwoDigitDateFormat(dateNow.getMonth() + 1).toString(),
      yearNow = dateNow.getFullYear().toString().substr(-2),
      hourNow = this.getTwoDigitDateFormat(dateNow.getHours()).toString(),
      minNow = this.getTwoDigitDateFormat(dateNow.getMinutes()).toString();
    // Le nom du dossier est maintenant basé sur la date/heure + random (l'ID utilisateur sera récupéré côté serveur)
    const customFolder = yearNow + monthNow + dayNow + hourNow + minNow + '_' + Math.floor(Math.random() * 9999999).toString();
    this.config.params.destinationFolder = customFolder;
    return customFolder;
  }

  createFolders(): Promise<any> {
    this.folderName = this.getRandomFolder();
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('folderName', this.folderName);

    this.mysqlSyncService.initSession(this.folderName);

    this.dataPassService.statusWaveformSource.next([]);

    return this.http.post(this.serverEndpoint + '/api/createFolders', body.toString(), { headers }).toPromise();
  }

  getConfigTable(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/api/getConfigTable', {}, { headers }).toPromise();
  }

  getProprietes(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getProprietes', { headers }).toPromise();
  }

  getCategories(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getCategories', { headers }).toPromise();
  }

  getGenresAssociation(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getGenresAssociation', { headers }).toPromise();
  }

  getStationWithGenresAssociation(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getStationWithGenresAssociation', { headers }).toPromise();
  }

  getWinmediaData(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getWinmediaData', { headers }).toPromise();
  }

  addFile(filename, metadata) {
    const pos = this.files.push({
      filename: filename,
      folder: this.folderName,
      metadata: metadata
    }) - 1;

    const statusWaveformCurrent = this.dataPassService.statusWaveformSource.getValue();
    statusWaveformCurrent.push({
      file: filename,
      status: 0
    });
    this.dataPassService.statusWaveformSource.next(statusWaveformCurrent);

    this.mysqlSyncService.dataID.push({
      file: filename
    });
    this.mysqlSyncService.newImport(filename, this.folderName, metadata, pos)
      .then(conn => {
        if (conn[0].error === 0) {
          this.mysqlSyncService.dataID[pos].id = conn[0].retour.insertId;
        }
      })
      .catch(err => console.log(err));
    this.generateWaveform(filename, pos)
      .then(r => {
        console.log('generateWaveform', r);
        const currentStatusWaveform = this.dataPassService.statusWaveformSource.getValue();
        if (r.error === 0) {
          currentStatusWaveform[Number(r.pos)].status = 1;
          this.dataPassService.statusWaveformSource.next(currentStatusWaveform);
        }
      })
      .catch(e => console.warn('generateWaveform', e));
    return pos;
  }

  generateWaveform(filename, pos) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('folder', this.folderName)
      .set('filename', filename)
      .set('position', pos.toString());
    return this.http.post<WaveformReturn>(this.serverEndpoint + '/api/generateWaveform',
      body.toString().replace(/\+/gi, '%2B'), { headers }).toPromise();
  }
}

export class WaveformReturn {
  error: number;
  retour: string;
  pos: string;
}
